<template>
  <v-container>
    <h2>Alertas</h2>
    <v-flex xs12 sm10 offset-sm1>

      <v-autocomplete
          :items="this.devices"
          v-model="device"
          label="Seleccione un dispositivo "
          hint="Dispositivo"
          single-line
          item-text="completeNameDevice"
          item-value="id"
          @change="changeDevice"
          return-object
      ></v-autocomplete>
    </v-flex>
    <br>
    <v-data-table v-if="notifications.length>0"
                  :headers="headers"
                  :items="notifications"
                  class="elevation-1"
                  sort-icon="mdi-menu-down"
                  :search="search"
                  hide-actions
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-left" width="200px">{{ formatDateMinus(props.item.date) }}</td>
        <td class="text-xs-left" >{{translateData(props.item.type)}}</td>
        <td class="text-xs-left">{{ translateData(props.item.status)}}</td>
        <td class="text-xs-left">{{ props.item.device }}</td>
        <td class="text-xs-left">{{ props.item.client }}</td>
        <td class="text-xs-left">
          <a target="_blank" v-if="props.item.positionId!='0'" @click="getLocation(props.item)">Ubicación</a>
        </td>
      </template>
      <v-alert slot="no-results" :value="true" color="error" icon="warning">
        No se han encontrado resultados para "{{ search }}".
      </v-alert>
    </v-data-table>
    <br>
    <download-excel :fetch="getReport"
                    style="width:200px"
                    name="reporte_notificacion.xls">
      <v-btn small color="primary">
        Reporte de notificaciones
        <v-icon right dark>cloud_download</v-icon>
      </v-btn>
    </download-excel>
    <v-dialog v-if="dialogInfo==true"
              v-model="dialogInfo"
              width="800px"
              transition="dialog-bottom-transition"
              scrollable>
      <v-card tile>
        <v-toolbar card dark color="nav_background_color">
          <v-btn icon dark @click.native="dialogInfo = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Información de ubicación</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <GmapMap
                ref="gmap"
                :center="this.mapView"
                :zoom="14"
                map-type-id="roadmap"
                :options="{
                      scaleControl: true,
                      mapTypeControl: true,
                      zoomControl: true,
                      scrollwheel: true,
                      gestureHandling: 'greedy'
                    }"
                style="width: 100%; height: 85vh"
            >
              <GmapMarker
                  :key="index"
                  v-for="(m, index) in markers"
                  :position="m.position"
                  :clickable="true"
                  :icon="m.icon"
              />
            </GmapMap>
          </v-form>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import Catalog from '../../model/Catalog';

export default {
  data() {
    return {
      search: '',
      valid: false,
      requiredField: [v => !!v || 'Es requerido'],
      dialog: false,
      dialogInfo: false,
      headers: [
        { text: 'Fecha y hora', value: 'date' },
        { text: 'Tipo notificación', value: 'type' },
        { text: 'Detalle', value: 'estado' },
        { text: 'Dispositivo', value: 'name' },
        { text: 'Cliente', value: 'id' },
        { text: 'Ubicación', value: 'catalogueItemId' },

      ],
      items: ['TIPO_DOCUMENTO'],
      editedIndex: -1,
      configuration:null,
      configurationClient:null,
      configurations:[],
      configurationsClient:[],
      catalog: new Catalog(),
      catalogParent: new Catalog(),
      users:[],
      notifications:[],
      roles:[],
      role:"",
      clients:[],
      client:"",
      devices:[],
      device:"",
      mapView: {lat: -0.190029, lng: -78.482114},
      markers: [],
    };
  },
  methods: {
    cleanData() {
      this.$refs.form.reset();
      this.catalog = new Catalog();
      this.catalogParent = new Catalog();
      this.valid = false;
      this.dialog = false;
    },
    newCatalog() {
      this.editedIndex = -1;
      this.valid = false;
      this.dialog = true;
      this.$refs.form.reset();
      this.catalog = new Catalog();
      this.catalogParent = new Catalog();
    },
    saveData() {
      if (this.$refs.form.validate()) {
        if(this.configuration.id==null){
          this.$store.dispatch('addAlarmConfiguration',this.configuration).then(
              response => {
                this.configuration = null
                this.role = ""
              },
              error => {
                this.$store.state.dialogError = true;
              }
          );
        }else{
          this.$store.dispatch('updateAlarmConfiguration',this.configuration).then(
              response => {
                this.configuration = null
                this.role = ""
              },
              error => {
                this.$store.state.dialogError = true;
              }
          );
        }
      }
    },
    saveDataClient() {
      if (this.$refs.form.validate()) {
        if(this.configurationClient.id==null){
          this.$store.dispatch('addAlarmConfiguration',this.configurationClient).then(
              response => {
                this.configurationClient = null
                this.client = ""
              },
              error => {
                this.$store.state.dialogError = true;
              }
          );
        }else{
          this.$store.dispatch('updateAlarmConfiguration',this.configurationClient).then(
              response => {
                this.configurationClient = null
                this.client = ""
              },
              error => {
                this.$store.state.dialogError = true;
              }
          );
        }
      }
    },
    editItem(item) {
      this.editedIndex = this.$store.state.catalogs.indexOf(item);
      this.catalog = Object.assign({}, item);
      for (var i = 0; i < this.$store.state.catalogs.length; i++) {
        this.catalogParent = this.$store.state.catalogs[i];
        var hasCatalogParent = false;
        if (this.catalogParent.id === this.catalog.catalogueItemId) {
          hasCatalogParent = true;
          break;
        }
        if (!hasCatalogParent) {
          this.catalogParent = {
            id: '',
            code: '',
            name: '',
            enabled: '',
            catalogueItemId: ''
          };
        }
      }
      this.dialog = true;
    },
    changeStatusItem(item) {
      this.editedIndex = this.notifications.indexOf(item);
      this.notifications[this.editedIndex].status = 'Leída'
    },
    getCatalogParentIdName(id) {
      for (var i = 0; i < this.$store.state.catalogs.length; i++) {
        if (this.$store.state.catalogs[i].id === id) {
          return id + ' - ' + this.$store.state.catalogs[i].name;
        }
      }
    },

    getLocation(item){
      this.editedIndex = this.notifications.indexOf(item);

      let queryParam = "id="+[this.notifications[this.editedIndex].positionId]
      this.$store.dispatch('getDevicesLocationTraccarReport',queryParam).then(
          response => {
            for (const dev of this.devices) {
                if(dev.idTraccar!=null && dev.idTraccar===this.notifications[this.editedIndex].idTraccar){
                  let image = dev.image
                  if(response.data.result[0].accStatus=='1' && parseInt(response.data.result[0].speed)>0){
                    image = image.replace("1.", "V.");
                  }else if(response.data.result[0].accStatus=='0'){
                    image = image.replace("1.", "R.");
                  }else if(response.data.result[0].accStatus=='1' && response.data.result[0].speed=='0'){
                    image = image.replace("1.", "A.");
                  }else{
                    image = image.replace("1.", "V.");
                  }
                  this.markers=[]
                  this.imageDevice = image
                  let respPosition = {
                    position: {
                      lat: response.data.result[0].lat,
                      lng: response.data.result[0].lng,
                    },
                    icon: {
                      url2: dev.image,
                      url: image,
                      scaledSize: {width: 40, height: 40, f: 'px', b: 'px'},
                      rotation: [45]
                    }
                  }
                  this.mapView = {
                    lat: response.data.result[0].lat,
                    lng: response.data.result[0].lng
                  }
                  this.markers.push(respPosition)
                  this.dialogInfo = true
                }
            }

          },
          error => {
            this.$store.state.dialogError = true;
          }
      );
    },
    changeRole(){
      this.$store.dispatch('getAlarmConfigurationByRole',this.role.name).then(
          response => {
            if(response.data==""){
              this.configuration= { roleId:this.role,
                configBotonPanico: true,
                configCorteCorriente: true,
                configFueraLinea: true,
                configExcesoVelocidad: true,
                configEncendidoMotor: true,
                configApagadoMotor: true,
                configEntradaGeocerca: true,
                configSalidaGeocerca: true,
                configBateriaBaja: true,
                configTiempoSinEntrar: true,
                configTiempoSinSalir: true,
                configMantenimiento: true,
                configColision: true,
              }
            }else{
              this.configuration = response.data
            }
          },
          error => {
            this.$store.state.dialogError = true;
          }
      );
    },
    changeClient(){
      this.$store.dispatch('getAlarmConfigurationByUser',this.client.id).then(
          response => {
            if(response.data==""){
              this.configurationClient= { user:this.client,
                configBotonPanico: true,
                configCorteCorriente: true,
                configFueraLinea: true,
                configExcesoVelocidad: true,
                configEncendidoMotor: true,
                configApagadoMotor: true,
                configEntradaGeocerca: true,
                configSalidaGeocerca: true,
                configBateriaBaja: true,
                configTiempoSinEntrar: true,
                configTiempoSinSalir: true,
                configMantenimiento: true,
                configColision: true,
              }
            }else{
              this.configurationClient = response.data
            }
          },
          error => {
            this.$store.state.dialogError = true;
          }
      );
    },

    changeDevice(){
      this.notifications=[]
      var dateTo= new Date().toISOString().slice(0, -1);
      var dateFrom = new Date();
      dateFrom.setMonth(dateFrom.getMonth() - 5);
      dateFrom = dateFrom.toISOString().slice(0, -1);
      let queryParam = ''
      if(this.device!=null && this.device.idTraccar!=null){
         queryParam = "deviceId="+this.device.idTraccar+"&from="+this.dateStart()+"&to="+this.dateEnd()
      }else if(this.device.id==null || this.device.id=='') {
        var dateFromDate = new Date();
        dateFromDate.setDate(dateFromDate.getDate() - 2);
        dateFromDate = dateFromDate.toISOString();
        queryParam = "from="+this.dateStart()+"&to="+this.dateEnd()
      }
      this.$store.dispatch('getDevicesLocationTraccarAlarm', queryParam).then(response => {
        if(response.data!=null && this.device!=null && this.device.id!=null){
          this.$store.dispatch('getDevice', this.device.id).then(responseDevice => {
            let object = JSON.parse(responseDevice.data.value)
            object.id = responseDevice.data.id
            object.selected = false
            object.user = responseDevice.data.user
            object.fullData = object.imei+" "+object.name
            response.data.device=object
             for (const notification of response.data) {
                 this.notifications.push({id:notification.id, date:notification.eventTime, type:notification.type, device:object.name, client:object.login, location:notification.latitude+","+notification.longitude, status:notification.attributes, positionId:notification.positionId, idTraccar:notification.deviceId})
             }
          })
        }else if(response.data!=null){
          for (const dev of this.devices) {
            for (const notification of response.data) {
              if(dev.idTraccar===notification.deviceId){
                if(JSON.stringify(notification.attributes) !== JSON.stringify({})){
                  this.notifications.push({id:notification.id, date:notification.eventTime, type:notification.type, device:dev.name, client:dev.login, location:notification.latitude+","+notification.longitude, status:notification.attributes, positionId:notification.positionId, idTraccar:notification.deviceId})
                }
              }
            }
          }
        }else{
          this.$store.state.dialogError = true;
          this.$store.state.dialogErrorMessage = "No existen notificaciones para el dispositivo seleccionado";
        }

      })
    },

    translateData(data){
      const dataTransform = JSON.stringify(data)
      if(dataTransform==='"commandResult"'){
        return 'Ejecución de comando'
      }else if(dataTransform==='{"result":"Cut off the fuel supply: Success!"}'){
        return 'Se ha cortado la energía!'
      }else if(dataTransform.toString()==='{"result":"Restore fuel supply: Success!"}'){
        return 'Se ha restablecido la energía!'
      }else if(dataTransform.toString()==='"deviceOffline"'){
        return 'Vehículo fuera de línea!'
      }else if(dataTransform.toString()==='"deviceOnline"'){
        return 'Vehículo en línea'
      }else if(dataTransform.toString()==='"ignitionOn"'){
        return 'Vehículo Encendido'
      }else if(dataTransform.toString()==='"ignitionOff"'){
        return 'Vehículo Apagado'
      }else if(dataTransform.toString()==='"alarm"'){
        return 'Alarma del Vehículo'
      }else if(dataTransform.toString()==='{"alarm":"sos"}'){
        return 'SOS Auxilio'
      }else if(dataTransform.toString()==='{"alarm":"powerCut"}'){
        return 'Corte de energía'
      }else if(dataTransform.toString()==='{"alarm":"lowBattery"}'){
        return 'Batería Baja'
      }else if(dataTransform.toString()==='{"alarm":"overspeed"}'){
        return 'Vehículo superó el límite de velocidad'
      }else if(dataTransform.toString().includes('Cut off the fuel supply: Success')){
        return 'Se ha cortado la energía!'
      }else if(dataTransform.toString().includes('"deviceMoving"')){
        return 'Vehículo en movimiento'
      }else if(dataTransform.toString().includes('"deviceStopped"')){
        return 'Vehículo detenido'
      }else if(dataTransform.toString().includes('"deviceUnknown"')){
        return 'Vehículo desconocido'
      }else if(dataTransform.toString().includes('"geofenceEnter"')){
        return 'Entra a Geocerca'
      }else if(dataTransform.toString().includes('"geofenceExit"')){
        return 'Sale de Geocerca'
      }else if(dataTransform.toString().includes('Already in the state')){
        return 'El Vehículo ya se encuentra en el estado solicitado. El comando no fue ejecutado'
      }else if(dataTransform.toString()==='{}'){
        return ''
      }else {
        return data
      }
    },

    dateStart(){
      let date = new Date();

      date.setTime(date.getTime() - (24 * 60 * 60 * 1000)); // Convert hours to milliseconds - 60 minutes to an hour, 60 seconds to a minute, 1000 milliseconds to a second

      var day = date.getDate() + "";
      var month = date.getMonth()+1 + "";
      var year = date.getFullYear()-1 + "";
      var hour = date.getHours()+"";
      var minutes = date.getMinutes() + "";
      var seconds = date.getSeconds() + "";


      day = this.checkZero(day);
      month = this.checkZero(month);
      year = this.checkZero(year);
      hour = this.checkZero(hour);
      minutes = this.checkZero(minutes);
      seconds = this.checkZero(seconds);

      return year + "-" + month + "-" + day + "T" + hour + ":" + minutes + ":" + seconds+"-05";
    },
    dateEnd(){
      let date = new Date();
      var day = date.getDate() + "";
      var month = date.getMonth()+1 + "";
      var year = date.getFullYear() + "";
      var hour = date.getHours() + "";
      var minutes = date.getMinutes() + "";
      var seconds = date.getSeconds() + "";

      day = this.checkZero(day);
      month = this.checkZero(month);
      year = this.checkZero(year);
      hour = this.checkZero(hour);
      minutes = this.checkZero(minutes);
      seconds = this.checkZero(seconds);

      return year + "-" + month + "-" + day + "T" + hour + ":" + minutes + ":" + seconds+"-05";
    },

    formatDateMinus(dateString){
      let date = new Date(dateString);
      var day = date.getDate() + "";
      var month = (date.getMonth() + 1) + "";
      var year = date.getFullYear() + "";
      var hour = (date.getHours());
      var minutes = date.getMinutes() + "";
      var seconds = date.getSeconds() + "";

      day = this.checkZero(day);
      month = this.checkZero(month);
      year = this.checkZero(year);
      hour = this.checkZero(hour);
      minutes = this.checkZero(minutes);
      seconds = this.checkZero(seconds);

      return year + "-" + month + "-" + day + " " + hour + ":" + minutes + ":" + seconds;
    },

    getFormattedDate(dateReg) {
      var ua = navigator.userAgent.toLowerCase();
      var date;
      if (true) {
        // Para Safari
        if (!(dateReg instanceof Date)) {
          var b = dateReg.toString().split(/\D/);
          date = new Date(Date.UTC(b[0], --b[1], b[2], b[3], b[4], b[5]));
        } else {
          date = new Date(dateReg);
        }
      } else {
        // Otros navegadores
        date = new Date(dateReg);
      }
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var hour = date.getHours();
      var min = date.getMinutes();
      var sec = date.getSeconds();
      month = (month < 10 ? "0" : "") + month;
      day = (day < 10 ? "0" : "") + day;
      hour = (hour < 10 ? "0" : "") + hour;
      min = (min < 10 ? "0" : "") + min;
      sec = (sec < 10 ? "0" : "") + sec;
      var str = date.getFullYear() + "-" + month + "-" + day + " " + hour + ":" + min + ":" + sec;
      return str;
    },
    checkZero(data){
      if(data.length === 1){
        data = "0" + data.toString();
      }
      return data;
    },

    async getReport() {
      this.$store.state.progress = true;
      var reportList = [];
      for (let i = 0; i < this.notifications.length; i++) {
        var notificationAux = new Object();

        if(this.device.id!=null){
          notificationAux.IDENTIFICADOR = this.device.id
          notificationAux.IMEI = this.device.imei
          notificationAux.ULTIMA_ACCION = this.device.lastAction
          notificationAux.CLIENTE_LOGIN = this.device.login
          notificationAux.CLIENTE_NOMBRE = this.device.name
          notificationAux.MODELO = this.device.model
        }
        notificationAux.FECHA = this.formatDateMinus(this.notifications[i].date);
        notificationAux.TIPO_NOTIFICACION = this.translateData(this.notifications[i].type);
        notificationAux.NOMBRE_DISPOSITIVO = this.notifications[i].device;
        notificationAux.CLIENTE = this.notifications[i].client;
        notificationAux.DETALLE = this.translateData(this.notifications[i].status);

        reportList.push(notificationAux);
      }
      // await this.$store.dispatch('getAllCovidsByCompanyResolve', true).then(
      //     response => {
      //
      //     },
      //     error => {
      //       this.$store.state.dialogError = true;
      //     }
      // );
      if (reportList.length == 0) {
        alert('No existen registros.');
      }
      this.$store.state.progress = false;
      return reportList;
    },

  },
  computed: {},
  beforeCreate() {
    this.$store.dispatch('getCatalogs').then(
      response => {
        this.cleanData();
      },
      error => {
        this.$store.state.dialogError = true;
      }
    );
  },
  created(){
    let search = ""
    search = this.$store.state.idUser
    this.$store.dispatch('getDevicesByUserLogin', search).then(response => {
      this.devices = []
      for (let i = 0; i < response.data.length; i++) {
        let object = JSON.parse(response.data[i].value)
        object.id = response.data[i].id
        object.selected = false
        object.user = response.data[i].user
        object.completeNameDevice = object.login + " - " + object.name
        this.devices.push(object)
      }
      if (search === 'grupooro357') {
                  try {
                      this.$store.dispatch('getOneUser', search).then(responseData => {
                          if (responseData.data.clientData != null) {
                              let clientData = JSON.parse(responseData.data.clientData)
                              if (clientData.userChildren && clientData.userChildren.length > 0) {
                                  for (let j = 0; j < clientData.userChildren.length; j++) {
                                      if (clientData.userChildren[j] != null && clientData.userChildren[j].login != null) {
                                          this.$store.dispatch('getOneUser', clientData.userChildren[j].login).then(responseDevices => {
                                              if (responseDevices.data.clientData) {
                                                  let clientDataForDevices = JSON.parse(responseDevices.data.clientData);
                                                  for (let z = 0; z < clientDataForDevices.devices.length; z++) {
                                                      this.devices.push(clientDataForDevices.devices[z]);
                                                  }
                                              }
                                          })
                                      }
                                  }

                              }

                          }

                      })
                  } catch (e) {
                    //ERROR TO PROCESS
                  }
                  ;
              }
      this.changeDevice()
    })


    this.roles = []
    this.$store.dispatch('getAllAuthorities').then(
        response => {
          this.roles = response.data
        },
        error => {
          this.$store.state.dialogError = true;
        }
    );

    this.$store.dispatch('getClients').then(response => {
          for (const user of response.data) {
            user.fullName = user.identification +" - "+user.firstName+" "+user.lastName
            this.clients.push(user)

          }
        },
        error => {
          this.$store.state.dialogError = true;
        })

  }

};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/alert/Alert.vue